
import { useEffect, useState } from "react";

// Context
import { Context } from "../Context/Context";

// json
import JsonFile from "../Utils/JsonFile";

// component
import Authenticated from "./Authenticated";
import UnAuthenticated from "./UnAuthenticated";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Loading from "../Components/Common/Loading";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { AllProvincesArray } from "../Data";

function App() {
    // Axios interceptors
    axios.interceptors.request.use((config) => {
        console.log("=== REQUEST ===");
        console.log(config);
        return config;
    }, (error) => {
        console.log("=== REQUEST ERROR ===");
        console.log(error);
        return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
        console.log("=== RESPONSE ===");
        console.log(response);
        return response;
    }, (error) => {
        console.log("=== RESPONSE ERROR ===");
        console.log(error);
        return Promise.reject(error);
    });

    const [language, setLanguage] = useState("fa");
    const [login, setLogin] = useState(false);
    const [json, setJson] = useState(JsonFile(window.localStorage.getItem("language")));

    // data state
    const [phoneNum, setPhoneNum] = useState(null);
    const [user, setUser] = useState("");
    const [uploadFile, setUploadFile] = useState();
    const [talkExpert, setTalkExpert] = useState(null);
    const [cart, setCart] = useState([]);
    const [loading, setLoading] = useState(false);
    const [provinceList, setProvinceList] = useState([...AllProvincesArray]);

    const { pathname } = useLocation();

    useEffect(() => {
        setLanguage(window.localStorage.getItem("language"));
        if (window.localStorage.getItem("cart")) {
            const myArray = window.localStorage.getItem("cart").split(",");
            setCart(myArray);
        } else {
            setCart([]);
        }
    }, []);

    useEffect(() => {
        setJson(JsonFile(language));
        if (language !== null) {
            window.localStorage.setItem("language", language);
        } else {
            window.localStorage.setItem("language", "fa");
        }
        if (window.localStorage.getItem("user")) {
            const token = JSON.parse(window.localStorage.getItem("user"));
            const now = new Date();
            if (now.getTime() > token.expireDate) {
                window.localStorage.removeItem("user");
                setLogin(false);
            } else {
                setUser(token.access);
                setLogin(true);
            }
        } else {
            setLogin(false);
        }
        language === "en" ? document.body.classList.add("ltr") : document.body.classList.remove("ltr");
    }, [language]);

    // To scroll page to top, when the route (path) changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname])

    const cartHandeler = (id) => {
        if (cart.find((item) => item === id)) {
            toast.error(json.toast.cart_2)
        } else {
            const newCart = [...cart, id];
            setCart(newCart);
            window.localStorage.setItem("cart", newCart);
            toast.success(json.toast.cart_1);
        }
    }

    const numberconvert = (number) => {
        // let num = number.toString().replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
        let num = number.toString().replaceAll(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
        return num;
    }

    //  showPasswordInput
    const showPasswordInput = () => {
        const showPasswordInput = document.querySelectorAll("[showpasswordinput]");
        showPasswordInput.forEach((input) => {
            const btn = document.createElement("button");
            btn.className = "input-frame-btnEmpty fs-6";
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/></svg>';
            btn.style.display = "none";
            btn.type = "button";
            btn.onclick = () => {
                if (input.type === "password") {
                    input.type = "text";
                    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16"><path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/><path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/><path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/></svg>';
                } else {
                    input.type = "password";
                    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/></svg>';
                }
            }
            input.after(btn);
            const cheackEmptyInput = () => {
                if (input.value.length === 0) {
                    btn.style.display = "none"
                } else {
                    btn.style.display = "block"
                }
            }
            window.addEventListener("click", cheackEmptyInput)
            window.addEventListener("load", cheackEmptyInput)
            input.addEventListener("keyup", cheackEmptyInput)
        });
    }

    return (
        <Context.Provider value={{
            json,
            setLanguage,
            login,
            setLogin,
            phoneNum,
            setPhoneNum,
            user,
            setUser,
            uploadFile,
            setUploadFile,
            talkExpert,
            setTalkExpert,
            cart,
            setCart,
            cartHandeler,
            numberconvert,
            showPasswordInput,
            loading,
            setLoading,
            provinceList,
            setProvinceList,
        }}>

            {login ? <Authenticated /> : <UnAuthenticated />}
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={language === "en" ? false : true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {loading ? <Loading /> : null}
        </Context.Provider>
    );
}

export default App;
